import styled from 'styled-components';
import { tokens } from '../../styles';

const handlePaddingTop = paddingTop => {
  return tokens.spacing[paddingTop] || tokens.spacing.xl;
};

/**
 * PageContainer
 * @param {string} paddingTop - the token string for the top padding
 */
const PageContainer = styled.main`
  max-width: 60vw;
  margin: 0 auto;

  // sets a padding for smaller screens
  padding-left: ${tokens.spacing.m};
  padding-right: ${tokens.spacing.m};

  // receive the padding top as prop or set 32px (xl) as default
  padding-top: ${({ paddingTop }) => handlePaddingTop(paddingTop)};

  // theme styles
  ${({ theme }) => ({ ...theme.page })}

  // remove the side padding for bigger screens
  @media ${tokens.mediaQueries.md} {
    padding-left: 0;
    padding-right: 0;
  }
`;

export default PageContainer;
